import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { getTokenOutAmount, GetTokenOutAmountProps } from '@/libs/sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { PublicClient } from 'viem';

export const useSellWin = (
  client: PublicClient,
  params?: GetTokenOutAmountProps,
  options?: CustomUseQueryOptions<bigint>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(params, true),
    queryKey: [queryKey, 'SellWin', params, client],
    queryFn: async () => await getTokenOutAmount(params!, client),
  });
};
